import { render, staticRenderFns } from "./VColWrapper.vue?vue&type=template&id=21ff6e83"
import script from "./VColWrapper.vue?vue&type=script&lang=js"
export * from "./VColWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports